import { motion } from "motion/react";
import { VERDICT_META, type Analysis } from "../../shared/types";
import { ExtractionTag } from "./ExtractionPanel";

/** A prompt as a tiny retro window: title bar = verdict, body = the prompt, footer = top noul. */
export function PromptCard({
  a,
  index = 0,
  onClick,
}: {
  a: Analysis;
  index?: number;
  onClick: () => void;
}) {
  const m = VERDICT_META[a.verdict];
  const onDark = a.verdict !== "suspicious";
  const ex = a.extraction;

  return (
    <motion.button
      onClick={onClick}
      initial={{ opacity: 0, y: 6 }}
      animate={{ opacity: 1, y: 0 }}
      transition={{ duration: 0.22, delay: Math.min(index * 0.006, 0.3) }}
      whileHover={{ x: -1, y: -1 }}
      className="win win-sm group flex h-full w-full flex-col text-left"
    >
      <div
        className="win-bar"
        style={{ background: m.accent, color: onDark ? "var(--paper)" : "var(--ink)" }}
      >
        <span className="font-bold tracking-[0.08em]">{m.label.toUpperCase()}</span>
        <span className="hatch" />
        <span className="tabular-nums opacity-80">{a.latencyMs}ms</span>
      </div>

      <div className="flex flex-1 flex-col gap-2 p-2.5">
        <p className="line-clamp-3 text-[11.5px] leading-[1.45]">{a.text}</p>

        <div className="mt-auto flex flex-col gap-1 border-t-[1.5px] border-dashed border-ink/25 pt-1.5 text-[10px]">
          <div className="flex items-center gap-1.5">
            <span className="truncate opacity-60">{a.topHazard}</span>
            <span className="ml-auto tabular-nums font-bold" style={{ color: m.accent }}>
              {a.topHazardScore.toFixed(2)}
            </span>
          </div>
          {ex && ex.level !== "clear" && (
            <ExtractionTag level={ex.level} score={ex.score} />
          )}
        </div>
      </div>
    </motion.button>
  );
}
